// List of dynamic placeholders available for the label template designer.
// Each element's text `content` may contain one or more of these {{tokens}}.
// Actual substitution happens using the map returned by the backend
// `/api/label/resolve` endpoint (see api/labelStudioApi.js -> resolvePlaceholders).

export const PLACEHOLDER_FIELDS = [
  { group: "Product", key: "product_name_en", label: "Product Name (English)" },
  { group: "Product", key: "product_name_mr", label: "Product Name (Marathi)" },
  { group: "Product", key: "brand_en", label: "Brand Name (English)" },
  { group: "Product", key: "brand_mr", label: "Brand Name (Marathi)" },
  { group: "Product", key: "description_en", label: "Description (English)" },
  { group: "Product", key: "description_mr", label: "Description (Marathi)" },
  { group: "Product", key: "category_en", label: "Category (English)" },
  { group: "Product", key: "category_mr", label: "Category (Marathi)" },
  { group: "Product", key: "veg_type", label: "Veg / Non Veg" },
  { group: "Product", key: "country_of_origin", label: "Country of Origin" },

  { group: "Pricing", key: "mrp", label: "MRP" },
  { group: "Pricing", key: "selling_price", label: "Selling Price" },
  { group: "Pricing", key: "discount", label: "Discount" },
  { group: "Pricing", key: "gst", label: "GST" },
  { group: "Pricing", key: "hsn_code", label: "HSN Code" },

  { group: "Packaging", key: "weight", label: "Net Weight" },
  { group: "Packaging", key: "pieces", label: "Pieces" },
  { group: "Packaging", key: "volume", label: "Volume" },

  { group: "Ingredients", key: "ingredients_en", label: "Ingredients (English)" },
  { group: "Ingredients", key: "ingredients_mr", label: "Ingredients (Marathi)" },

  { group: "Nutrition", key: "nutrition.energy", label: "Energy" },
  { group: "Nutrition", key: "nutrition.protein", label: "Protein" },
  { group: "Nutrition", key: "nutrition.fat", label: "Fat" },
  { group: "Nutrition", key: "nutrition.carbohydrates", label: "Carbohydrates" },
  { group: "Nutrition", key: "nutrition.sugar", label: "Sugar" },
  { group: "Nutrition", key: "nutrition.fibre", label: "Fibre" },
  { group: "Nutrition", key: "nutrition.sodium", label: "Sodium" },
  { group: "Nutrition", key: "nutrition.iron", label: "Iron" },
  { group: "Nutrition", key: "nutrition.calcium", label: "Calcium" },

  { group: "Manufacturer", key: "manufacturer", label: "Manufacturer Name" },
  { group: "Manufacturer", key: "address", label: "Address" },
  { group: "Manufacturer", key: "email", label: "Email" },
  { group: "Manufacturer", key: "phone", label: "Phone" },
  { group: "Manufacturer", key: "website", label: "Website" },
  { group: "Manufacturer", key: "fssai", label: "FSSAI Number" },

  { group: "Storage", key: "storage_en", label: "Storage Instructions (English)" },
  { group: "Storage", key: "storage_mr", label: "Storage Instructions (Marathi)" },

  { group: "Batch", key: "batch", label: "Batch Number" },
  { group: "Batch", key: "manufacturing_date", label: "Manufacturing Date" },
  { group: "Batch", key: "packed_date", label: "Packed Date" },
  { group: "Batch", key: "expiry", label: "Expiry Date" },
  { group: "Batch", key: "best_before", label: "Best Before" },

  { group: "Weighing Scale", key: "weight_kg", label: "Live Weight (kg)" },
  { group: "Weighing Scale", key: "rate_per_kg", label: "Rate per Kg" },
  { group: "Weighing Scale", key: "calculated_price", label: "Calculated Price" },

  { group: "Identifiers", key: "sku", label: "SKU" },
  { group: "Identifiers", key: "barcode", label: "Barcode Value" },
  { group: "Identifiers", key: "qr", label: "QR Value" },
];

// Replace all {{token}} occurrences in `text` using values from `dataMap`.
// Unknown tokens are left as-is so the designer can still show placeholders
// before a product is selected.
export function resolvePlaceholderText(text, dataMap) {
  if (!text) return "";
  if (!dataMap) return text;
  return text.replace(/{{\s*([\w.]+)\s*}}/g, (match, key) => {
    return Object.prototype.hasOwnProperty.call(dataMap, key) ? dataMap[key] : match;
  });
}
